import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, Button, Table, TableBody, TableCell,
  TableHead, TableRow, Paper, IconButton, Chip, Alert, CircularProgress,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminVehicleModels = () => {
  const navigate = useNavigate();
  const [models, setModels] = useState([]);
  const [brands, setBrands] = useState([]);
  const [filterBrand, setFilterBrand] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axiosInstance.get('/vehiclebrands').then(res => setBrands(res.data)).catch(() => {});
    fetchModels();
  }, []);

  const fetchModels = async (brandId = '') => {
    setLoading(true);
    try {
      const url = brandId ? `/vehiclemodels?brandId=${brandId}` : '/vehiclemodels';
      const res = await axiosInstance.get(url);
      setModels(res.data);
    } catch {
      setError('Modeller yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  const handleBrandFilter = (val) => {
    setFilterBrand(val);
    fetchModels(val);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu modeli silmek istediğinizden emin misiniz?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axiosInstance.delete(`/vehiclemodels/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModels(prev => prev.filter(m => m.id !== id));
    } catch {
      setError('Silme işlemi başarısız.');
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" fontWeight={700}>Araç Modelleri</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/admin/vehicles/models/new')}>
          Yeni Model
        </Button>
      </Box>
      <FormControl sx={{ mb: 2, minWidth: 200 }}>
        <InputLabel>Markaya Göre Filtrele</InputLabel>
        <Select label="Markaya Göre Filtrele" value={filterBrand} onChange={e => handleBrandFilter(e.target.value)}>
          <MenuItem value="">Tümü</MenuItem>
          {brands.map(b => <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>)}
        </Select>
      </FormControl>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <Paper>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.main' }}>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Model</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Marka</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Slug</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Sıra</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Durum</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }} align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {models.map(m => (
                <TableRow key={m.id} hover>
                  <TableCell><strong>{m.name}</strong></TableCell>
                  <TableCell>{m.brandName}</TableCell>
                  <TableCell>{m.slug}</TableCell>
                  <TableCell>{m.displayOrder}</TableCell>
                  <TableCell>
                    <Chip label={m.status ? 'Aktif' : 'Pasif'} color={m.status ? 'success' : 'default'} size="small" />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton color="primary" onClick={() => navigate(`/admin/vehicles/models/edit/${m.id}`)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" onClick={() => handleDelete(m.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {models.length === 0 && (
                <TableRow><TableCell colSpan={6} align="center">Henüz model eklenmemiş.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Container>
  );
};

export default AdminVehicleModels;
